import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Blocks the app shell (`Layout`'s children) while the user still has a
 * temp password. Registered as `canActivateChild` — not `canActivate` — on
 * the `Layout` route, because Angular only re-runs `canActivate` when that
 * route node is freshly entered, not on every sibling-to-sibling navigation
 * within an already-matched shell.
 */
export const mustChangePasswordGuard: CanActivateChildFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.mustChangePassword()) {
    return router.parseUrl('/change-password');
  }
  return true;
};
